import { h } from "preact"

export default function EyeIcon({ className, slashed = false }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            focusable="false"
            role="img"
            viewBox="0 0 640 512"
            className={className}
            style={{ height: "1em", width: "1.25em", verticalAlign: "-0.125em", display: "inline-block" }}
        >
            {slashed ? (
                <path
                    fill="currentColor"
                    d="M634 471L36 3.5C28.6-2.3 18-1 12.1 6.4L4.9 15.4c-5.8 7.4-4.6 18 2.8 23.8L605.5 508.5c7.4 5.8 18 4.6 23.8-2.8l7.2-9c5.8-7.4 4.6-18-2.8-23.8zM296.8 146.5l134.8 105.4C429.4 191.7 361.2 142.6 296.8 146.5zM343.2 365.5L208.4 260.1C210.6 320.3 278.8 369.4 343.2 365.5zM320 112c98.7 0 189.1 55 237.9 144-14.9 27.2-33.6 51.4-55.7 72.2l37.7 29.5c26.9-25.9 49.7-56.2 67.2-90.1 5.4-10.5 5.4-22.9 0-33.4C561.4 128.8 447.9 64 320 64c-36.9 0-72.5 5.5-106.1 15.6L254 110.6c21.4-4.5 43.4-6.6 66-6.6zM320 400c-98.7 0-189.1-55-237.9-144 14.9-27.2 33.6-51.4 55.7-72.2l-37.7-29.5c-26.9 25.9-49.7 56.2-67.2 90.1-5.4 10.5-5.4 22.9 0 33.4C78.6 383.2 192.1 448 320 448c36.9 0 72.5-5.5 106.1-15.6L386 401.4c-21.4 4.5-43.4 6.6-66 6.6z"
                />
            ) : (
                <path
                    fill="currentColor"
                    transform="translate(32 0)"
                    d="M288 144a110.9 110.9 0 0 0-31.2 5 55.4 55.4 0 0 1 7.2 27 56 56 0 0 1-56 56 55.4 55.4 0 0 1-27-7.2A111.7 111.7 0 1 0 288 144zm284.5 97.4C518.3 135.6 410.9 64 288 64S57.7 135.6 3.5 241.4a32.4 32.4 0 0 0 0 29.2C57.7 376.4 165.1 448 288 448s230.3-71.6 284.5-177.4a32.4 32.4 0 0 0 0-29.2zM288 400c-98.7 0-189.1-55-237.9-144C98.9 167 189.3 112 288 112s189.1 55 237.9 144C477.1 345 386.7 400 288 400z"
                />
            )}
        </svg>
    )
}
